import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const CREATE_ENTERPRISE = 'CREATE_ENTERPRISE';
export const CREATE_ENTERPRISE_SUCCESS = 'CREATE_ENTERPRISE_SUCCESS';
export const CREATE_ENTERPRISE_FAILURE = 'CREATE_ENTERPRISE_FAILURE';

// Action Creators
export const createEnterprise = () => ({
  type: CREATE_ENTERPRISE,
});

export const createEnterpriseSuccess = (data) => ({
  type: CREATE_ENTERPRISE_SUCCESS,
  payload: data,
});

export const createEnterpriseFailure = (error) => ({
  type: CREATE_ENTERPRISE_FAILURE,
  payload: error,
});

// Thunk Function
export const createEnterpriseCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(createEnterprise());
    try {
      const response = await postMethodWithToken(url.enterprise, data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(createEnterpriseSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(createEnterpriseFailure(response?.data));
      }
    } catch (error) {
      dispatch(createEnterpriseFailure(error?.message));
    }
  };
};
